import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import type { Section } from "~/providers/section-provider";

interface CashRegisterState {
  dayOverviewOpen: boolean;
  setDayOverviewOpen: (open: boolean) => void;
  selectedCategoryId?: string;
  setSelectedCategoryId: (categoryId: string) => void;
  selectedSection?: Section;
  setSelectedSection: (section: Section) => void;
  selectedTableId?: string;
  setSelectedTableId: (tableId?: string) => void;
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
  setMobileProductsCollapsed: (collapsed: boolean) => void;
  mobileProductsCollapsed: boolean;
  endDayOpen: boolean;
  setEndDayOpen: (open: boolean) => void;
  orderSettingsOpen: boolean;
  setOrderSettingsOpen: (open: boolean) => void;
  mutationDialogOpen: boolean;
  setMutationDialogOpen: (open: boolean) => void;
}

export const useRegisterStore = create<CashRegisterState>()(
  devtools(
    persist(
      (set) => ({
        searchInput: "",
        endDayOpen: false,
        dayOverviewOpen: false,
        orderSettingsOpen: false,
        mutationDialogOpen: false,
        setMutationDialogOpen(open) {
          set(() => ({ mutationDialogOpen: open }));
        },
        setOrderSettingsOpen(open) {
          set(() => ({ orderSettingsOpen: open }));
        },
        setDayOverviewOpen(open) {
          set(() => ({ dayOverviewOpen: open }));
        },
        setEndDayOpen(open) {
          set(() => ({ endDayOpen: open }));
        },
        mobileProductsCollapsed: false,
        setMobileProductsCollapsed(collapsed) {
          set(() => ({ mobileProductsCollapsed: collapsed }));
        },
        setSelectedSection: (selectedSection) =>
          set(() => ({ selectedSection })),
        setSelectedCategoryId: (categoryId) =>
          set(() => ({ selectedCategoryId: categoryId })),
        setSelectedTableId(tableId) {
          set(() => ({ selectedTableId: tableId }));
        },
        setSearchInput: (searchInput) =>
          set(() => ({ searchInput: searchInput })),
      }),
      {
        name: "register-storage",
      },
    ),
  ),
);
